import { useLayoutEffect, useContext, useRef } from "react";
import { getMenuItems } from "./menuDefinitions";
import { StoreContext } from "../../store/Store";
import { actionTypes } from "../../store/storeTypes";
import { GlobalRefContext } from "../../store/GlobalRefs";

const tickerstyle = {
  position: "relative",
  paddingLeft: 10,
  paddingRight: 10,
  border: "1px solid black",
  backgroundColor: "#F28E2B",
  cursor: "pointer",
  width: 140,
};

const tickerstyleHidden = {
  position: "relative",
  width: 0,
};

export const MenuSelection = ({
  menukey,
  defaultSelection,
  label,
  inputType,
  data,
  hide,
}) => {
  const [store, dispatch] = useContext(StoreContext);
  const { auth, controlPopupMenu } = store;
  const grefs = useContext(GlobalRefContext);
  const fetchInProgress = useRef(false);
  const hasFetched = useRef(false);

  const hasMenuItems = menukey in controlPopupMenu.menuItems;

  useLayoutEffect(() => {
    let isCancelled = false;

    if (hasFetched.current || fetchInProgress.current || hasMenuItems) {
      return;
    }

    if (auth && data && data.length > 0) {
      fetchInProgress.current = true;
      
      const asyncfunction = async () => {
        const mitems = await getMenuItems(
          menukey,
          auth,
          grefs.tickerStorage.current,
          data
        );
        if (grefs.controlRefs.current[menukey].current) {
          if (!isCancelled) {
            hasFetched.current = true;
            dispatch({
              type: actionTypes.SET_CONTROL_POPUP_MENU,
              payload: {
                menuItems: {
                  ...controlPopupMenu.menuItems,
                  [menukey]: mitems,
                },
                showPopup: false,
                type: { ...controlPopupMenu.type, [menukey]: inputType },
                selected: {
                  ...controlPopupMenu.selected,
                  [menukey]: defaultSelection,
                },
                label: "",
              },
            });
          }
        }
        fetchInProgress.current = false;
      };
      asyncfunction();
    }
    return () => {
      isCancelled = true;
    };
  }, [
    auth,
    dispatch,
    menukey,
    defaultSelection,
    inputType,
    grefs,
    data,
    hasMenuItems,
    controlPopupMenu.menuItems,
    controlPopupMenu.type,
    controlPopupMenu.selected,
  ]);

  const onClick = () => {
    dispatch({
      type: actionTypes.SET_CONTROL_POPUP_MENU,
      payload: {
        ...controlPopupMenu,
        showPopup: true,
        label: menukey,
      },
    });
  };

  const createLabel = () => {
    if (inputType === "radio") {
      return `${label} (${
        controlPopupMenu.selected[menukey]
          ? controlPopupMenu.selected[menukey]
          : defaultSelection
      })`;
    } else {
      return label;
    }
  };
  return (
    <div
      ref={grefs.controlRefs.current[menukey]}
      style={hide === true ? tickerstyleHidden : tickerstyle}
      onClick={() => onClick()}
    >
      {hide === true ? "" : createLabel()}
    </div>
  );
};
